import { useHistory, useLocation } from "react-router-dom";
import useFixedHeader from "./useFixedHeader";
import { scrollToElementById, setHash } from "../util/scrollToElement";

export default function useScrollToElement({ isMobileDevice, isTabletDevice }) {
  const { isHeaderFixed } = useFixedHeader();
  const history = useHistory();
  const location = useLocation();

  const scroll = (id, setHashFlag) => {
    setHashFlag && setHash(`#${id}`, location.pathname, history);
    scrollToElementById(id, isHeaderFixed, isMobileDevice, isTabletDevice);
  };
  return { scroll };
}
